import axios from 'axios';
import { useCookies } from 'vue3-cookies';

const API_BASE_URL = import.meta.env.VITE_API_URL;

export function useDonor() {
  const { cookies } = useCookies();

  const insertDonorToDB = async (donateInfo, repeat = null) => {
    // โหมดแนบสลิปย้อนหลัง: ผู้บริจาคเลือกไว้แล้วที่หน้าก่อนหน้าว่าจะผูกกับ Donation เดิม
    // ห้าม INSERT และห้ามเช็กคุกกี้ isDonate ก่อน — คุกกี้ค้างจากรายการอื่นจะทำให้สลิป
    // ไปแปะผิดแถว ต้องเขียนทับด้วย donateid ที่ผู้บริจาคเพิ่งเลือกเสมอ
    if (repeat && repeat.mode === 'attach_slip' && repeat.donateid) {
      cookies.set(
        'isDonate',
        { donorid: repeat.donateid, idNumber: donateInfo.personal_id },
        '30min'
      );
      return true;
    }

    if (cookies.get('isDonate')) {
      return true;
    }

    try {
      let result = await axios.get(
        `${API_BASE_URL}/donate/${donateInfo.personal_id}/${donateInfo.amount}/${donateInfo.campaignID}`
      );

      if (result.data.DONATEID === 0) {
        // repeatConfirmed บอก backend ให้ log ว่าแถวนี้เกิดขึ้นทั้งที่ผู้บริจาคเห็นคำเตือนแล้ว
        // เจ้าหน้าที่จะได้แยกออกจาก Ghost Row ตอนไล่ตรวจย้อนหลัง
        const payload =
          repeat && repeat.mode === 'new'
            ? {
                ...donateInfo,
                repeatConfirmed: true,
                previousDonateid: repeat.previousDonateid,
                repeatShownAction: repeat.shownAction
              }
            : donateInfo;
        const response = await axios.post(`${API_BASE_URL}/donate`, payload);
        cookies.set(
          'isDonate',
          { donorid: response.data.DONATEID, idNumber: response.data.IDENTIFICATION_NUMBER },
          '30min'
        );
      } else {
        cookies.set(
          'isDonate',
          { donorid: result.data.DONATEID, idNumber: donateInfo.personal_id },
          '30min'
        );
      }
      return true;
    } catch (error) {
      console.error('Error inserting donor:', error);
      return false;
    }
  };

  return {
    insertDonorToDB,
  };
}
